// 生成与spm对应的checksum
const makeSpmChkSum = s => {
  s = (s || '').split('#')[0].split('?')[0];
  const len = s.length;
  const hash = s => {
    const l = s.length;
    let key = 0;
    for (let i = 0; i < l; i++) {
      key = key * 31 + s.charCodeAt(i);
    }
    return key;
  };
  return len ? hash(len + '#' + s.charCodeAt(len - 1)) : -1;
};

const setSpmRaw = value => {
  const { spmA, spmB } = value || {};
  if (!spmA || !spmB) {
    console.log('spmA and spmB must be specified');
    return;
  }

  const spm = spmA + '.' + spmB;
  const checksum = makeSpmChkSum(spm);

  // 注：goldlog的加载是异步的，页面加载完成后不一定已经有goldlog对象
  const goldlogTimer = setInterval(() => {
    const goldlog = window.goldlog;
    if (goldlog) {
      console.log('start to set spm', value, checksum, goldlog);
      // 手动修改spm-b位,并发送正确的spm统计信息
      goldlog.setPageSPM &&
        goldlog.setPageSPM(spmA, spmB, () => {
          goldlog.sendPV && goldlog.sendPV({ page_id: '', checksum });
        });
      clearInterval(goldlogTimer);
      //console.log('new spm: ' + spm);
    }
  }, 1000);

  // 10秒如果还没有检测到新的aplus.js,则clearInterval, 不然每秒执行也是资源开销
  setTimeout(() => {
    const goldlog = window.goldlog;
    if (!goldlog || !goldlog.setPageSPM) {
      clearInterval(goldlogTimer);
    }
  }, 10000);
};

export default setSpmRaw;



// WEBPACK FOOTER //
// ./src/components/tracker/setSpm.js